export default "__VITE_PUBLIC_ASSET__787522e5__"